export const useCouponsTemplate = () => {
  return {
    type: 3, // 模板类型 0通兑券 3满减券
    floorAmount:'', //满
    couponPrice:'', //减
    hallType: 0, // 0:全部 1普通厅可用 2特殊厅可用
    useType: 0, //位置数量：0全部1234对应其他的
    useTypeRadio:0,
    cinemaStandardStr: "全部影院",
    cinemaClassifyId:[], //选中的影院
    cinemaFilterType: 0, //0:全部影院 1:指定影院分类
    movieIdType: 0, // 影片类型
    movieIdSelectList: [], //选中的影片
    name: '', //券名称
    id:'',
    classifyCode:[],
  }
}

export const useSetTemplateFrom = (data) => {
  let templateFromData = useCouponsTemplate()
  const { cinemaClassifyId,classifyCode } = data.movieTemplateLimitJson;
  console.log("🚀 ~ useSetTemplateFrom ~ cinemaClassifyId:", cinemaClassifyId)
  templateFromData.type = data.type
  templateFromData.floorAmount = data.floorAmountBd || ''
  templateFromData.couponPrice = data.couponPriceBd || ''
  templateFromData.hallType = data.movieTemplateLimitJson.hallType
  templateFromData.useTypeRadio = data.useType ? 1 : 0
  templateFromData.useType = data.useType
  templateFromData.cinemaStandardStr = data.movieTemplateLimitJson.cinemaFilterType === 0 ? '全部影院' : data.movieTemplateLimitJson.cinemaClassifyName
  templateFromData.cinemaClassifyId = cinemaClassifyId ? cinemaClassifyId.split(',') : []
  templateFromData.cinemaFilterType = data.movieTemplateLimitJson.cinemaFilterType
  templateFromData.movieIdType = data.movieTemplateLimitJson.movieIdStr ? 1 : 0
  templateFromData.movieIdSelectList = data.movieTemplateLimitJson.movieIdStr ? data.movieTemplateLimitJson.movieIdStr.split(',').map(Number) : []
  templateFromData.name = data.name
  templateFromData.id = data.id ? data.id : ''
  templateFromData.classifyCode = classifyCode ? classifyCode.split(',') : []
  console.log(templateFromData,'templateFromDatatemplateFromData')
  return templateFromData
}



// WEBPACK FOOTER //
// ./src/components/useCouponsTemplate.js